import { defineNuxtPlugin, useCookie } from '#app'

type SupportedLocale = 'en-US' | 'es-MX' | 'fr-FR' | 'de-DE'

export default defineNuxtPlugin(nuxtApp => {
    const rememberedLocale = useCookie<SupportedLocale | undefined>(
        'cpx_locale'
    )

    // Restore the remembered locale during plugin setup so the app starts in
    // the saved language before locale-aware components render.
    if (
        rememberedLocale.value === 'en-US' ||
        rememberedLocale.value === 'es-MX' ||
        rememberedLocale.value === 'fr-FR' ||
        rememberedLocale.value === 'de-DE'
    ) {
        nuxtApp.$i18n.locale.value = rememberedLocale.value
    }
})
